




























import Vue from 'vue';
import { Track } from '@/interfaces/track';

export default Vue.extend({
  name: 'MusicCard',
  props: {
    track: {
      required: true,
      type: Object as () => Track,
    },
  },
  data() {
    return {
      addToFavorites: 'Ajouter aux favoris',
      removeFromFavorites: 'Retirer des favoris',
    };
  },
  methods: {
    toggle() {
      this.$store.dispatch('updateFavorites', this.track);
    },
  },
  computed: {
    isFavorite(): Boolean {
      return this.$store.state.FAVORITES
        .map((item: Track) => item.id)
        .includes(this.track.id);
    },
  },
});
